// Getters (GET*)
export const PRINT_GET_PARAMS = 'GET_PRINT_PAGE';
export const PRINT_GET_PRINT_MODE = 'PRINT_GET_PRINT_MODE';
export const PRINT_GET_TABLE_MODE = 'PRINT_GET_TABLE_MODE';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const PRINT_SET_PARAMS = 'PRINT_SET_PARAMS';
export const PRINT_SET_PRINT_MODE = 'PRINT_SET_PRINT_MODE';
export const PRINT_SET_TABLE_MODE = 'PRINT_SET_TABLE_MODE';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const PRINT_UPDATE_PARAMS = 'PRINT_UPDATE_PARAMS';
export const PRINT_ENABLE_PRINT_MODE = 'PRINT_ENABLE_PRINT_MODE';
export const PRINT_DISABLE_PRINT_MODE = 'PRINT_DISABLE_PRINT_MODE';
export const PRINT_ENABLE_TABLE_MODE = 'PRINT_ENABLE_TABLE_MODE';
export const PRINT_DISABLE_TABLE_MODE = 'PRINT_DISABLE_TABLE_MODE';
export const PRINT_TOGGLE_PRINT_MODE = 'PRINT_TOGGLE_PRINT_MODE';
export const PRINT_TOGGLE_TABLE_MODE = 'PRINT_TOGGLE_TABLE_MODE';
